/*花瓣提醒的服务*/
define('services/mysetting/petals.service',['app'], function (app) {

    return app.factory('petalsService', ['$q', 'ngDialog', '$state', 'auiAgreementHelper', 'auiDialog', 'modBussService','OpenUp', function ($q, ngDialog, $state, auiAgreementHelper, auiDialog, modBussService, OpenUp) {
        var today = new Date().getTime();
        var after2Month = new Date().getTime() + sysParamCfg.today2MonthTime;

        function handleDailogForPetals(latestUserInfo) {
            var defer = $q.defer();
            if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                modBussService.getBussinesInfoMsg(latestUserInfo).then(function (data) {
                    var checkIsReminderUser = latestUserInfo.id + ":" + systemParaConf.petals.petalsTips;
                    //判断境外银行状态
                    var enBankState = 0;
                    if (data.bankInfoEN) {
                        if (data.bankInfoEN.verifyBankState == 1 || data.bankInfoEN.updateBankState == 1) {
                            enBankState = 1;
                        }
                    }
                    //判断花瓣的相关的逻辑  1.有花瓣白名单 2.商户国内已经审核通过并且所有的商户信息不再审核中 3.只有主帐号提示，4.审核中不要检查 5.更名中不要检查 6.不是在商户页面跳出的 7.超过5次不提示 成员帐号暂时不提示因为提示了也没有用 基于这两点判断协议是否需要签署
                    if (data.bankInfoCN && data.bankInfoCN.verifyBankState == 2 && data.bankInfoCN.updateBankState != 1
                        && enBankState != 1 && latestUserInfo.verifyRealState != 1 && latestUserInfo.updateRealState != 1
                        && latestUserInfo.isChangeRealName != 1) {
                        if (~~localStorage.getItem(checkIsReminderUser) < systemParaConf.petals.petalsTipsLastTime) {
                            //判断2个协议是否需要签署
                            auiAgreementHelper.queryAgreements([systemParaConf.petalsAgreements.tremPdfConfType, systemParaConf.petalsAgreements.ServicePdfConfType]).then(function (signInfo) {
                                //是银行卡认证 芝麻认证或者 是企业打款 并且没有三证合一图片 并且已经签署过协议
                                if (((latestUserInfo.verifyType == 3 && !latestUserInfo.contactorImg10) || ((latestUserInfo.verifyType == 4 ||
                                    latestUserInfo.verifyType == 2) && !latestUserInfo.perCtfFg) ||
                                        (latestUserInfo.userType == 2 && !latestUserInfo.corpBsLicID) || !data.bankInfoCN.mercShortName) &&
                                    (signInfo.signInfoList[0] && signInfo.signInfoList[1] && (signInfo.signInfoList[0].signStatus == 1 || signInfo.signInfoList[0].signStatus == 2) &&
                                        (signInfo.signInfoList[1].signStatus == 1 || signInfo.signInfoList[1].signStatus == 2))) {
                                    //  已经签署2个协议了缺少实名认证情况下，分缺少商务简称与不缺商户简称
                                    if (!data.bankInfoCN.mercShortName && ((latestUserInfo.verifyType == 3 && !latestUserInfo.contactorImg10) || ((latestUserInfo.verifyType == 4 ||
                                        latestUserInfo.verifyType == 2) && !latestUserInfo.perCtfFg) || (latestUserInfo.userType == 2 && !latestUserInfo.corpBsLicID))) {
                                        //缺实名认证缺商务简称
                                        localStorage.setItem(checkIsReminderUser, ~~localStorage.getItem(checkIsReminderUser) + 1);
                                        auiDialog.warn("信息未完善", "尊敬的开发者，您的实名认证信息和商户信息不完善，为了向您提供更优质和专业的商户服务，请您先完善实名认证信息再确认商户服务信息中的商户简称并提交。")
                                    } else if (data.bankInfoCN.mercShortName) {
                                        //缺实名认证  不缺商务简称
                                        localStorage.setItem(checkIsReminderUser, ~~localStorage.getItem(checkIsReminderUser) + 1);
                                        auiDialog.warn("信息未完善", "尊敬的开发者，您的实名认证信息不完善，为了向您提供更优质和专业的商户服务，请您完善实名认证信息。", function () {
                                            $state.go('mysetting.userInfo', {}, {reload: true});
                                            defer.resolve();
                                        })
                                    } else {
                                        // 不缺实名   缺商户
                                        auiDialog.warn("信息未完善", "尊敬的开发者，您的商户服务信息不完善，为了向您提供更优质和专业的商户服务，请您确认商户服务信息中的商户简称并提交。", function () {
                                            $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                                            defer.resolve();
                                        })
                                    }
                                } else if (signInfo.signInfoList[0] && signInfo.signInfoList[1]) {
                                    if (signInfo.signInfoList[0].signStatus == 3 || signInfo.signInfoList[1].signStatus == 3) {
                                        var agreementTip = "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请查看相关协议。";
                                        if ((latestUserInfo.verifyType == 3 && !latestUserInfo.contactorImg10) || ((latestUserInfo.verifyType == 4 || latestUserInfo.verifyType == 2) && !latestUserInfo.perCtfFg) || (latestUserInfo.userType == 2 && !latestUserInfo.corpBsLicID) || !data.bankInfoCN.mercShortName) {
                                            //都缺
                                            if (!data.bankInfoCN.mercShortName && ((latestUserInfo.verifyType == 3 && !latestUserInfo.contactorImg10) || ((latestUserInfo.verifyType == 4 || latestUserInfo.verifyType == 2) && !latestUserInfo.perCtfFg) || (latestUserInfo.userType == 2 && !latestUserInfo.corpBsLicID))) {
                                                //缺少实名认证，缺少商户简称
                                                agreementTip = "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请查看相关协议。另外，您的实名认证信息和商户信息不完善，请您先完善实名认证信息再确认商户服务信息中的商户简称并提交。";

                                            } else if (data.bankInfoCN.mercShortName) {
                                                //缺少实名认证，不缺商户简称
                                                agreementTip = "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请查看相关协议。另外，您的实名认证信息不完善，请您完善实名认证信息。";
                                            } else {
                                                //缺商户简称
                                                agreementTip = "尊敬的开发者，为了向您提供更优质的商户资金结算服务，我们的商户资金结算服务由华为旗下的讯联智付网络有限公司提供，我们会将您的相关信息同步至该公司，该变化不会对您当前使用的服务和权益造成影响。关于服务的提供和您个人数据的使用，请查看相关协议。另外，您的商户服务信息不完善，请您确认商户服务信息中的商户简称并提交。";

                                            }

                                            auiDialog.confirm("信息提醒", agreementTip, function () {
                                                window.localStorage.removeItem(checkIsReminderUser);
                                                auiAgreementHelper.checkAgreements([{
                                                    agrType: systemParaConf.petalsAgreements.tremPdfConfType,
                                                    country: 'cn',
                                                    count: 1
                                                }, {
                                                    agrType: systemParaConf.petalsAgreements.ServicePdfConfType,
                                                    country: 'cn',
                                                    count: 1
                                                }], function () {
                                                    defer.resolve();
                                                }, undefined, true).then(function (rs) {
                                                    if (rs && rs.signed == true) {
                                                        //判断是否直接到补充信息
                                                        if (((latestUserInfo.verifyType == 3 && !latestUserInfo.contactorImg10) || ((latestUserInfo.verifyType == 4 || latestUserInfo.verifyType == 2) && !latestUserInfo.perCtfFg)) && data.bankInfoCN.mercShortName) {
                                                            $state.go('mysetting.userInfo', {}, {reload: true});
                                                        } else if (!((latestUserInfo.verifyType == 3 && !latestUserInfo.contactorImg10) || ((latestUserInfo.verifyType == 4 || latestUserInfo.verifyType == 2) && !latestUserInfo.perCtfFg)) && !data.bankInfoCN.mercShortName) {
                                                            $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                                                        }
                                                        defer.resolve();
                                                    } else {
                                                        defer.resolve();
                                                    }
                                                });
                                            }, function () {
                                                defer.resolve();
                                                localStorage.setItem(checkIsReminderUser, ~~localStorage.getItem(checkIsReminderUser) + 1);
                                            });
                                        }else {
                                            handleOperationInfo(defer, latestUserInfo, data);
                                        }
                                    } else {
                                        handleOperationInfo(defer, latestUserInfo, data)
                                    }
                                } else {
                                    handleOperationInfo(defer, latestUserInfo, data)
                                }
                            })
                        } else {
                            handleOperationInfo(defer, latestUserInfo ,data)
                        }
                    } else {
                        window.localStorage.removeItem(checkIsReminderUser);
                        handleOperationInfo(defer, latestUserInfo ,data)
                    }
                });
            } else if (AUI.HDGWCall.getUserInfoValue('teamid') && latestUserInfo.isAdmin) {
                var checkPetalsCorpBsLicTeamExpiring = AUI.HDGWCall.getUserInfoValue('teamid') + ":" + systemParaConf.petals.petalsCorpBsLicTeamExpiring;//即将过期
                var checkPetalsCorpBsLicTeamExpired = AUI.HDGWCall.getUserInfoValue('teamid') + ":" + systemParaConf.petals.petalsCorpBsLicTeamExpired;//已经过期
                var checkPetalsLegalManCtfTeamExpiring = AUI.HDGWCall.getUserInfoValue('teamid') + ":" + systemParaConf.petals.petalsLegalManCtfTeamExpiring;//即将过期
                var checkPetalsLegalManCtfTeamExpired = AUI.HDGWCall.getUserInfoValue('teamid') + ":" + systemParaConf.petals.petalsLegalManCtfTeamExpired;//已经过期
                var checkPetalsPerManCtfTeamExpiring = AUI.HDGWCall.getUserInfoValue('teamid') + ":" + systemParaConf.petals.petalsPerManCtfTeamExpiring;//即将过期
                var checkPetalsPerManCtfTeamExpired = AUI.HDGWCall.getUserInfoValue('teamid') + ":" + systemParaConf.petals.petalsPerManCtfTeamExpired;//已经过期
                if (latestUserInfo.userType == 2) {
                    //企业证件已过期场景
                    if ((latestUserInfo.corpBsLicExpDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.corpBsLicExpDate) < today) || (latestUserInfo.orgCodeExpDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.orgCodeExpDate) < today)) {
                        if (~~localStorage.getItem(checkPetalsCorpBsLicTeamExpired) >= systemParaConf.petals.petalsCorpBsLicTeamExpiredLastTime) {
                            defer.resolve();
                        } else {
                            auiDialog.warn("证件信息提醒", "您当前团队的企业证件已过期，请及时更新证件，以免影响您的团队在华为开发者联盟的业务运营。", function () {
                                localStorage.setItem(checkPetalsCorpBsLicTeamExpired, ~~localStorage.getItem(checkPetalsCorpBsLicTeamExpired) + 1);
                                window.localStorage.removeItem(checkPetalsCorpBsLicTeamExpiring);
                                defer.resolve();
                            })
                        }
                    } else if ((latestUserInfo.corpBsLicExpDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.corpBsLicExpDate) < after2Month) || (latestUserInfo.orgCodeExpDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.orgCodeExpDate) < after2Month)) {
                        if (~~localStorage.getItem(checkPetalsCorpBsLicTeamExpiring) >= systemParaConf.petals.petalsCorpBsLicTeamExpiringLastTime) {
                            defer.resolve();
                        } else {
                            auiDialog.warn("证件信息提醒", "您当前团队的企业证件即将过期，请时更新证件，以免影您的团队在华为开发者联盟的业务运营。", function () {
                                localStorage.setItem(checkPetalsCorpBsLicTeamExpiring, ~~localStorage.getItem(checkPetalsCorpBsLicTeamExpiring) + 1);
                                window.localStorage.removeItem(checkPetalsCorpBsLicTeamExpired);
                                defer.resolve();
                            })
                        }
                    } else {
                        window.localStorage.removeItem(checkPetalsCorpBsLicTeamExpiring);
                        window.localStorage.removeItem(checkPetalsCorpBsLicTeamExpired);
                        //企业法人身份证已过期
                        if (latestUserInfo.legalManCtfExpDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.legalManCtfExpDate) < today) {
                            if (~~localStorage.getItem(checkPetalsLegalManCtfTeamExpired) >= systemParaConf.petals.petalsLegalManCtfTeamExpiredLastTime) {
                                defer.resolve();
                            } else {
                                auiDialog.warn("证件信息提醒", "您当前团队提供的身份证已过期，请及时更新证件，以免影响您的团队在华为开发者联盟的业务运营。", function () {
                                    localStorage.setItem(checkPetalsLegalManCtfTeamExpired, ~~localStorage.getItem(checkPetalsLegalManCtfTeamExpired) + 1);
                                    window.localStorage.removeItem(checkPetalsLegalManCtfTeamExpiring);
                                    defer.resolve();
                                })
                            }
                        } else if (latestUserInfo.legalManCtfExpDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.legalManCtfExpDate) < after2Month) {
                            if (~~localStorage.getItem(checkPetalsLegalManCtfTeamExpiring) >= systemParaConf.petals.petalsLegalManCtfTeamExpiringLastTime) {
                                defer.resolve();
                            } else {
                                auiDialog.warn("证件信息提醒", "您当前团队提供的身份证即将过期，请及时更新证件，以免影响您的团队在华为开发者联盟的业务运营。", function () {
                                    localStorage.setItem(checkPetalsLegalManCtfTeamExpiring, ~~localStorage.getItem(checkPetalsLegalManCtfTeamExpiring) + 1);
                                    window.localStorage.removeItem(checkPetalsLegalManCtfTeamExpired);
                                    defer.resolve();
                                })
                            }
                        } else {
                            window.localStorage.removeItem(checkPetalsLegalManCtfTeamExpiring);
                            window.localStorage.removeItem(checkPetalsLegalManCtfTeamExpired);
                            defer.resolve();
                        }
                    }
                } else if (latestUserInfo.userType == 1) {
                    if (latestUserInfo.ctfExpireDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.ctfExpireDate) < today) {//身份证到期提醒
                        if (~~localStorage.getItem(checkPetalsPerManCtfTeamExpired) >= systemParaConf.petals.petalsPerManCtfTeamExpiredLastTime) {
                            defer.resolve();
                        } else {
                            auiDialog.warn("证件信息提醒", "您当前团队帐号持有者的身份证已过期，请及时更新证件，以免影响您的团队在华为开发者联盟的业务运营。", function () {
                                localStorage.setItem(checkPetalsPerManCtfTeamExpired, ~~localStorage.getItem(checkPetalsPerManCtfTeamExpired) + 1);
                                window.localStorage.removeItem(checkPetalsPerManCtfTeamExpiring);
                                defer.resolve();
                            })
                        }
                    } else if (latestUserInfo.ctfExpireDate && AUI.DateUtil.DateStr2UtcMills(latestUserInfo.ctfExpireDate) < after2Month) {//身份证即将到期
                        if (~~localStorage.getItem(checkPetalsPerManCtfTeamExpiring) >= systemParaConf.petals.petalsPerManCtfTeamExpiringLastTime) {
                            defer.resolve();
                        } else {
                            auiDialog.warn("证件信息提醒", "您当前团队帐号持有者的身份证即将过期，请时更新证件，以免影响您的团队在华为开发者联盟的业务运营。", function () {
                                localStorage.setItem(checkPetalsPerManCtfTeamExpiring, ~~localStorage.getItem(checkPetalsPerManCtfTeamExpiring) + 1);
                                window.localStorage.removeItem(checkPetalsPerManCtfTeamExpired);
                                defer.resolve();
                            })
                        }
                    } else {
                        window.localStorage.removeItem(checkPetalsPerManCtfTeamExpiring);
                        window.localStorage.removeItem(checkPetalsPerManCtfTeamExpired);
                        defer.resolve();
                    }
                } else {
                    defer.resolve();
                }
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        function handleOperationInfo(defer, latestUserInfo, data) {
            if((data.bankInfoCN && (data.bankInfoCN.updateBankState === 1 || data.bankInfoCN.verifyBankState === 1))
                || (data.bankInfoEN && (data.bankInfoEN.updateBankState === 1 || data.bankInfoEN.verifyBankState === 1)) ||
                latestUserInfo.isChangeRealName === 1) {
                defer.resolve();
            } else {
                //petalPayCertifyStatus == 1  表示已经入网
                if(data.bankInfoCN && data.bankInfoCN.verifyBankState === 2 && data.petalPayCertifyStatus == 1 && latestUserInfo.specialAccountType !== 2) {
                    OpenUp.getOperationInfo({ req: {}}).then(function (res) {
                        if(res.resultCode === 0) {
                            if(!res.merchantBusinessInfo) {
                                auiDialog.warn("商户信息提示", "尊敬的开发者，您的商户经营信息未完善。为了向您提供更优质和专业的商户服务，请您尽快前往【商户服务】，选择真实的经营场景，并按照相应要求填写境内APP或PC网站信息。",
                                    function () {
                                    $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                                    defer.resolve();
                                })
                            }else {
                                defer.resolve();
                            }
                        }else {
                            defer.resolve();
                        }
                    })
                }else {
                    defer.resolve();
                }
            }


        }

        return {
            'handleDailogForPetals': handleDailogForPetals
        }
    }]);
});

